export const config = [
  {
    name: "Nicole",
    audio: "https://storage.googleapis.com/eleven-public-cdn/audio/marketing/nicole.mp3",
    tags: ["American", "Whispering"],
    colors: {
      50: "bg-[#FBF6FE]",
      200: "bg-[#EEDBF9]",
      300: "bg-[#E1BEF4]",
    },
    hue: 0,
  },
  {
    name: "Luna",
    audio: "https://storage.googleapis.com/eleven-public-cdn/audio/marketing/luna.mp3",
    tags: ["Mysterious", "Gaming"],
    colors: {
      50: "bg-[#FCFCEA]",
      200: "bg-[#F6F092]",
      300: "bg-[#EFDE44]",
    },
    hue: 128,
  },
  {
    name: "Fin",
    audio: "https://storage.googleapis.com/eleven-public-cdn/audio/marketing/fin.mp3",
    tags: ["Lively", "Irish"],
    colors: {
      50: "bg-[#ECFDF4]",
      200: "bg-[#A7F3CC]",
      300: "bg-[#6EE7B1]",
    },
    hue: 200,
  },
  {
    name: "George",
    audio: "https://storage.googleapis.com/eleven-public-cdn/audio/marketing/george.mp3",
    tags: ["Soothing", "Audiobook"],
    colors: {
      50: "bg-[#F2F5FC]",
      200: "bg-[#C8D5F4]",
      300: "bg-[#A1BAEC]",
    },
    hue: 300,
  },
];
